import { render, staticRenderFns } from "./UpsellSuggestions.vue?vue&type=template&id=f1f050c6&scoped=true"
import script from "./UpsellSuggestions.vue?vue&type=script&lang=js"
export * from "./UpsellSuggestions.vue?vue&type=script&lang=js"
import style0 from "./UpsellSuggestions.vue?vue&type=style&index=0&id=f1f050c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f050c6",
  null
  
)

export default component.exports